import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpErrorResponse,
  HttpResponse,
} from "@angular/common/http";
import { catchError, tap } from "rxjs/operators";
import { throwError } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { ErrorComponent } from "./pages/error/error.component";
import { ErrorService } from "./pages/error/error.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AuthService } from "./pages/auth/authServices";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private dialog: MatDialog,
    private errorService: ErrorService,
    private toastr: ToastrService,
    private snackBar: MatSnackBar,
    private router: Router,
    private authService: AuthService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          // Handle successful responses here if needed
        }
      }),
      catchError((error: HttpErrorResponse) => {
        const isSessionInactivityError =
          error.error?.errorCode === AuthService.SESSION_INACTIVITY_ERROR_CODE;

        if (isSessionInactivityError) {
          this.authService.handleServerSessionInactivityExpired();
          if (this.authService.getIsAuth()) {
            this.authService.showSessionExpiredDialog();
          } else {
            this.authService.reconcileExpiredSessionAfterRefresh();
          }
        } else if (this.authService.isSessionExpiredDueToInactivity()) {
          if (this.authService.getIsAuth()) {
            this.authService.showSessionExpiredDialog();
          } else {
            this.authService.reconcileExpiredSessionAfterRefresh();
          }
          return throwError(error);
        }

        const requestUrl = req.url || "";
        const isEncounterEmailConflict =
          req.method === "POST" &&
          /\/admin\/(?:create_encounter|create_pi_encounter|update_encounter\/[^/?#]+)(?:[?#]|$)/i.test(requestUrl) &&
          error.status === 409 &&
          error.error?.code === "PARTY_EMAIL_CONFLICT" &&
          Array.isArray(error.error.conflicts) &&
          error.error.conflicts.length > 0;
        // Encounter and SIBTF forms handle this response in the email resolution dialog.
        if (isEncounterEmailConflict) {
          return throwError(error);
        }

        // Doc download/preview errors are handled by FileDownloadService with a clearer toast.
        const isDocStreamRequest = /\/api\/v1\/oqme\/doc\//i.test(requestUrl);
        const isPrintPdfRequest = /\/admin\/print-queue\/[^/]+\/print-pdf/i.test(requestUrl);
        const isPrintStatusUpdate =
          req.method === "PUT" &&
          /\/admin\/print-queue\/[^/]+\/status$/i.test(requestUrl);
        if (isDocStreamRequest || isPrintPdfRequest || isPrintStatusUpdate) {
          return throwError(error);
        }

        // Local dev has no config.json. ConfigService falls back to the default API URL.
        if (requestUrl.includes("/config.json")) {
          return throwError(error);
        }

        let errorMessage = "Oops! Something went wrong.";

        if (error.error?.message) {
          errorMessage = error.error.message;
        }

        this.toastr.error(errorMessage, "", {
          timeOut: 3000,
          closeButton: true,
        });

        return throwError(error);
      })
    );
  }
}
